import React, { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Typography,
  Container,
  Paper,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ColorModeContext from "../../layout/themeContext";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f4f6f8",
    padding: theme.spacing(4, 2),
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 800,
    margin: "0 auto",
    borderRadius: 12,
  },
  header: {
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  },
  logo: {
    height: "50px",
    width: "auto",
    marginBottom: theme.spacing(2)
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: "#333",
  },
  text: {
    color: "#555",
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  },
  backButton: {
    alignSelf: "flex-start",
    marginBottom: theme.spacing(2),
  }
}));

const Privacy = () => {
  const classes = useStyles();
  const { colorMode } = useContext(ColorModeContext);
  
  const appName = colorMode.appAppName || "ZapBot";
  const logoSrc = colorMode.appLogoLight || colorMode.appLogoFavicon;

  return (
    <div className={classes.root}>
      <Helmet>
        <title>Política de Privacidade - {appName}</title>
      </Helmet>

      <Container maxWidth="md">
        <Button
          component={RouterLink}
          to="/login"
          startIcon={<ArrowBackIcon />}
          className={classes.backButton}
          color="primary"
        >
          Voltar para o Login
        </Button>

        <Paper className={classes.paper} elevation={2}>
          <div className={classes.header}>
            {logoSrc && <img src={logoSrc} alt={appName} className={classes.logo} />}
            <Typography variant="h4" className={classes.title}>
              Política de Privacidade
            </Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Última atualização: {new Date().toLocaleDateString('pt-BR')}
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              1. Coleta de Informações
            </Typography>
            <Typography className={classes.text}>
              O {appName} coleta informações de identificação pessoal (como nome, e-mail, telefone) quando você cria uma conta. Além disso, a plataforma processa e armazena os dados de mensagens e atendimentos transitados por meio de suas conexões em seu nome, a fim de prestar o serviço de CRM e Multiatendimento.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              2. Uso das Informações
            </Typography>
            <Typography className={classes.text}>
              As informações que coletamos são usadas para:
              <br/>
              - Fornecer, operar e manter os serviços e ferramentas da nossa plataforma.
              <br/>
              - Melhorar, personalizar e expandir os recursos oferecidos.
              <br/>
              - Compreender e analisar como você usa o sistema e desenvolver novos fluxos.
              <br/>
              - Processar de forma segura suas transações de assinatura.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              3. Proteção e Armazenamento de Dados
            </Typography>
            <Typography className={classes.text}>
              O {appName} adota práticas e medidas de segurança técnicas e organizacionais adequadas para proteger seus dados contra acesso não autorizado, alteração ou destruição. 
              Garantimos o sigilo das mensagens transitadas, as quais são de propriedade exclusiva do proprietário da conta. Nós não comercializamos os seus contatos ou conversas.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              4. Compartilhamento de Informações
            </Typography>
            <Typography className={classes.text}>
              O {appName} não compartilha informações de identificação pessoal nem dados de clientes e atendimentos da sua base com terceiros, exceto quando necessário para cumprir conformidades legais (ordens judiciais), proteger nossos direitos ou, em casos estritos de integração de API/Webhook habilitada ativamente por você no sistema.
            </Typography>
          </div>

          <div className={classes.section}>
            <Typography variant="h6" className={classes.sectionTitle}>
              5. Seus Direitos (LGPD)
            </Typography>
            <Typography className={classes.text}>
              Você tem total controle sobre os dados de sua conta. Se desejar exportar, corrigir ou excluir definitivamente os dados da plataforma, basta realizar as ações através do próprio painel administrativo ou solicitar o encerramento da conta contatando o suporte.
            </Typography>
          </div>

        </Paper>
      </Container>
    </div>
  );
};

export default Privacy;
